// Liste des sujets valides
export const validTopics: string[] = [
  "Suggestions d'ajout de service / besoin",
  "Mon compte",
  "Mon profil",
  "Abonnement",
  "Mes demandes de troc",
  "Mes propositions de troc",
  "Mes éléments d'échange",
  "Autre"
];